import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BSEContainer } from './Components/bseStyle';
import BSEComponent from './Components/BSEComponent';
import Spinner from '../../../../../../components/Spinner';
import Modal from '../../../../components/Modal/Modal';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import ErrorMessage from '../../../requests/ChangeCareerCampusModality/info/components/Modals/ErrorMessage';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import routes from '../../../../../../components/Routes/routingMap';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';

interface BSEviewProps {
  propProcedure: any;
  handlerRedirectNewPage: any;
  handleRequestProcedure: (
    setShowModalNotAvailable: (flag: boolean) => void,
    setShowModalExistRequest: (flag: boolean) => void,
    setShowModalNotAllowed: (flag: boolean) => void
  ) => void;
  error: any;
}

const BSEview = (grupo: BSEviewProps) => {
  const {
    propProcedure,
    handleRequestProcedure,
    handlerRedirectNewPage,
    error
  } = grupo;
  const history = useHistory();
  const handleBackButton = () => history.goBack();

  const [showModalNotAvailable, setShowModalNotAvailable] = useState(false);
  const [showModalExistRequest, setShowModalExistRequest] = useState(false);
  const [showModalNotAllowed, setShowModalNotAllowed] = useState(false);

  const handleCloseModalNotAvailable = () => {
    setShowModalNotAvailable(false);
  };

  const handleCloseModalNotAllowed = () => {
    setShowModalNotAllowed(false);
  };

  const handleCloseModalExistRequest = () => {
    setShowModalExistRequest(false);
  };

  const handleExistRequest = () => {
    setShowModalExistRequest(false);
    history.push(
      routes.student.procedures.categories.scholarships.bse.register
    );
    // dispatch al detalle del tramite enviando el requestId
    // redireccionar al progreso
  };

  return (
    <ModuleContainer containerType="subsection" data-testid="cmp-pseInforView">
      <SubsectionHeader
        title="Beca socioeconómica"
        onClick={handleBackButton}
      />
      {/* <SubContainer>
        <BackButton onClick={handleBackButton} />
        <Title>Beca socioeconómica</Title>
      </SubContainer> */}
      <SubContainer>
        <BSEContainer>
          {propProcedure ? (
            <div style={{ width: '100%' }}>
              <BSEComponent
                propProcedure={propProcedure}
                handlerRedirectNewPage={handlerRedirectNewPage}
                handleRequestProcedure={() =>
                  handleRequestProcedure(
                    setShowModalNotAvailable,
                    setShowModalExistRequest,
                    setShowModalNotAllowed
                  )
                }
              />
            </div>
          ) : (
            <Spinner />
          )}
          <Modal
            show={showModalNotAvailable}
            handleClose={handleCloseModalNotAvailable}
          >
            <NotAvailable handleClick={handleCloseModalNotAvailable} />
          </Modal>
          <Modal
            show={showModalExistRequest}
            handleClose={handleCloseModalExistRequest}
          >
            <RequestExist handleClick={handleExistRequest} />
          </Modal>
          <Modal
            show={showModalNotAllowed}
            handleClose={handleCloseModalNotAllowed}
          >
            <ErrorMessage
              showIcon
              title={error?.title}
              message="Revisa los requisitos para la solicitud de Beca."
              handleClick={() => setShowModalNotAllowed(false)}
            />
          </Modal>
        </BSEContainer>
      </SubContainer>
    </ModuleContainer>
  );
};
export default BSEview;
